.ColumnsVisibilityBadges {
  display: flex;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: var(--space-sm);

  .ShowColumnButton {
    padding: var(--space-xs) var(--space-sm);
    flex-shrink: 0;

    [data-slot="icon"] {
      height: 20px;
    }
  }
}

.ColumnsVisibilityPopoverContent {
  max-height: 300px;
  min-width: var(--content-min-width);
  overflow: hidden;
  padding: var(--space-sm) var(--space-xs);
  display: flex;
  flex-direction: column;

  .ScrollShadow {
    max-height: 100%;
    overflow: auto;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: var(--space-md);
  }

  .ExtraColumnList {
    max-height: 100%;
    overflow: auto;
    display: flex;
    flex-direction: column;
    gap: var(--space-xs);
    align-items: stretch;
  }

  .ExtraColumnGroup {
    display: flex;
    flex-direction: column;
    gap: var(--space-xs);

    & > span {
      text-transform: uppercase;
      color: var(--primary);
      font-size: 0.75rem;
      padding: var(--space-xs) var(--space-sm);
    }
  }

  .ExtraColumnButton {
    width: 100%;
    border-color: transparent;
    text-align: left;

    &:has(> [data-slot="icon"]) {
      grid: auto / max-content auto;
    }

    &:focus-visible {
      outline-offset: -2px;
    }
  }
}
